import { ethers } from "ethers";
import {PublicKey} from "@solana/web3.js";

export const chains: Array<Chain> = [
    {
        mode: 'SOLANA',
        nameId: 'solana',
        tokenBridgeAddress: 'wormDTUJ6AWPNvk59vGQbDvGJmqbDTdgWgAqcLBCgUb',
        wChainId: 1,
        chainId: 0,
        chainName: 'Solana',
        fullChainName: 'Solana Chain',
        rpcURL: 'https://rpc.ankr.com/solana',
        currencySymbol: 'SOL',
        blockExplorer: 'https://solscan.io',
        logoURI: '/assets/SOL.png',
        mayanContractAddress: 'FC4eXxkyrMPTjiYUpp4EAnkmwMbQyZ6NDCh1kfLn6vsf',
        wrapContractAddress: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
        explorerName: 'Solscan',
        baseToken: {
            mint: 'So11111111111111111111111111111111111111112',
            name: "SOL",
            symbol: "SOL",
            wChainId: 1,
            chainId: 0,
            decimals: 9,
            contract: ethers.ZeroAddress,
            coingeckoId: "sol",
            wrappedAddress: 'So11111111111111111111111111111111111111112',
            logoURI: '/assets/SOL.png',
        },
    },
    {
        mode: 'SOLANA',
        tokenBridgeAddress: '',
        wChainId: 51,
        chainId: 1110111,
        nameId: 'fogo',
        chainName: 'Fogo',
        fullChainName: 'Fogo Chain',
        rpcURL: 'https://rpc.hellomoon.io/34d462f9-1e8e-45b0-a83d-c3c43981ede0',
        externalRpcURL: undefined,
        currencySymbol: 'FOGO',
        blockExplorer: 'https://explorer.fogo.io',
        logoURI: 'https://cdn.mayan.finance/FOGO.png',
        mayanContractAddress: '',
        wrapContractAddress: 'So11111111111111111111111111111111111111112',
        baseToken: {
            mint: 'So11111111111111111111111111111111111111112',
            name: 'FOGO',
            symbol: 'FOGO',
            wChainId: 51,
            chainId: 1110111,
            decimals: 9,
            contract: '0x0000000000000000000000000000000000000000',
            coingeckoId: 'solana',
            wrappedAddress: 'So11111111111111111111111111111111111111112',
            logoURI: 'https://cdn.mayan.finance/FOGO.png',
            verified: true,
        },
        explorerName: 'FogoScan'
    },
    {
        mode: 'EVM',
        nameId: 'ethereum',
        tokenBridgeAddress: '0x3ee18B2214AFF97000D974cf647E7C347E8fa585',
        wChainId: 2,
        chainId: 1,
        chainName: 'Ethereum',
        fullChainName: 'Ethereum Mainnet',
        rpcURL: 'https://mainnet.infura.io/v3',
        currencySymbol: 'ETH',
        blockExplorer: 'https://etherscan.io',
        externalRpcURL: 'https://ethereum-rpc.publicnode.com',
        logoURI: '/assets/eth.png',
        mayanContractAddress: '0x80F53dcf568bE566F99Ab9F37eaa2B3AA10B3C95',
        wrapContractAddress: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
        explorerName: 'Etherscan',
        baseToken: {
            mint: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
            name: "ETH",
            symbol: "ETH",
            wChainId: 2,
            chainId: 1,
            decimals: 18,
            contract: ethers.ZeroAddress,
            coingeckoId: "weth",
            wrappedAddress: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
            logoURI: '/assets/eth.png',
        },
        swiftFee: {
            tokens: [
                {
                    symbol: 'USDC',
                    logoURI: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389',
                    decimals: 6,
                    contract: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
                },
                {
                    symbol: 'USDT',
                    logoURI: 'https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663',
                    decimals: 6,
                    contract: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
                },
                {
                    symbol: 'WETH',
                    logoURI: 'https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295',
                    decimals: 18,
                    contract: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                },
            ],
            feeManagers: ['0x26227ACE40de5671e8355fCAFf65a0522aa7b303', '0x54914A963c4197172130C26D496a367bD6609D88']
        }
    },
    {
        mode: 'EVM',
        nameId: 'bsc',
        tokenBridgeAddress: '0xB6F6D86a8f9879A9c87f643768d9efc38c1Da6E7',
        wChainId: 4,
        chainId: 56,
        fullChainName: 'Binance Smart Chain Mainnet',
        chainName: 'BSC',
        blockExplorer: 'https://bscscan.com',
        currencySymbol: 'BNB',
        rpcURL: 'https://bsc-dataseed1.binance.org',
        logoURI: 'https://cdn.mayan.finance/BSC_N.png',
        mayanContractAddress: '0x80F53dcf568bE566F99Ab9F37eaa2B3AA10B3C95',
        wrapContractAddress: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        explorerName: 'BscScan',
        baseToken: {
            mint: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
            name: "BNB",
            symbol: "BNB",
            wChainId: 4,
            chainId: 56,
            decimals: 18,
            contract: ethers.ZeroAddress,
            coingeckoId: "wbnb",
            wrappedAddress: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
            logoURI: '/assets/bsc.png',
        },
        swiftFee: {
            tokens: [
                {
                    symbol: 'USDC',
                    logoURI: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389',
                    decimals: 18,
                    contract: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
                },
                {
                    symbol: 'USDT',
                    logoURI: 'https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663',
                    decimals: 18,
                    contract: '0x55d398326f99059fF775485246999027B3197955',
                },
            ],
            feeManagers: ['0x26227ACE40de5671e8355fCAFf65a0522aa7b303', '0x54914A963c4197172130C26D496a367bD6609D88']
        }
    },
    {
        mode: 'EVM',
        nameId: 'polygon',
        tokenBridgeAddress: '0x5a58505a96D1dbf8dF91cB21B54419FC36e93fdE',
        wChainId: 5,
        chainId: 137,
        chainName: 'Polygon',
        fullChainName: 'Polygon',
        rpcURL: 'https://polygon-rpc.com',
        currencySymbol: 'MATIC',
        blockExplorer: 'https://polygonscan.com',
        externalRpcURL: 'https://polygon-mainnet.g.alchemy.com/v2/rX2NW-TfXUgdctNEj2kRSv9lY2521Ks6',
        logoURI: '/assets/polygon.png',
        mayanContractAddress: '0x80F53dcf568bE566F99Ab9F37eaa2B3AA10B3C95',
        wrapContractAddress: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
        explorerName: 'polygonscan',
        baseToken: {
            mint: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
            name: "Matic",
            symbol: "MATIC",
            wChainId: 5,
            chainId: 137,
            decimals: 18,
            coingeckoId: 'wmatic',
            contract: ethers.ZeroAddress,
            wrappedAddress: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
            logoURI: '/assets/polygon.png',
        },
        swiftFee: {
            tokens: [
                {
                    symbol: 'USDC',
                    logoURI: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389',
                    decimals: 6,
                    contract: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
                },
                {
                    symbol: 'USDT',
                    logoURI: 'https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663',
                    decimals: 6,
                    contract: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
                },
            ],
            feeManagers: ['0x26227ACE40de5671e8355fCAFf65a0522aa7b303', '0x54914A963c4197172130C26D496a367bD6609D88']
        }
    },
    {
        mode: 'EVM',
        nameId: 'avalanche',
        tokenBridgeAddress: '0x0e082F06FF657D94310cB8cE8B0D9a04541d8052',
        wChainId: 6,
        chainId: 43114,
        chainName: 'Avalanche',
        fullChainName: 'Avalanche (C-Chain)',
        logoURI: '/assets/avax-icon.png',
        // externalRpcURL: 'https://avalanche-mainnet.infura.io/v3/fb24d8d1782a43dc8336ca18d95e278a',
        rpcURL: 'https://avalanche-c-chain-rpc.publicnode.com',
        mayanContractAddress: '0x80F53dcf568bE566F99Ab9F37eaa2B3AA10B3C95',
        wrapContractAddress: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        blockExplorer: 'https://snowtrace.io',
        currencySymbol: 'AVAX',
        baseToken: {
            mint: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
            name: "Avax",
            symbol: "AVAX",
            wChainId: 6,
            chainId: 43114,
            decimals: 18,
            coingeckoId: 'wrapped-avax',
            contract: ethers.ZeroAddress,
            wrappedAddress: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
            logoURI: '/assets/avax-icon.png',
        },
        swiftFee: {
            tokens: [
                {
                    symbol: 'USDC',
                    logoURI: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389',
                    decimals: 6,
                    contract: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
                },
            ],
            feeManagers: ['0x26227ACE40de5671e8355fCAFf65a0522aa7b303', '0x54914A963c4197172130C26D496a367bD6609D88']
        },
        explorerName: 'SnowTrace',
    },
    {
        mode: 'EVM',
        nameId: 'arbitrum',
        tokenBridgeAddress: '0x0b2402144Bb366A632D14B83F244D2e0e21bD39c',
        wChainId: 23,
        chainId: 42161,
        chainName: 'Arbitrum',
        fullChainName: 'Arbitrum (One)',
        logoURI: 'https://cdn.mayan.finance/arbitrum-logo.png',
        externalRpcURL: 'https://arb1.arbitrum.io/rpc',
        rpcURL: 'https://arb1.arbitrum.io/rpc',
        mayanContractAddress: '0x80F53dcf568bE566F99Ab9F37eaa2B3AA10B3C95',
        wrapContractAddress: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
        blockExplorer: 'https://arbiscan.io',
        explorerName: 'Arbiscan',
        currencySymbol: 'ETH',
        baseToken: {
            mint: "CSD6JQMvLi46psjHdpfFdr826mF336pEVMJgjwcoS1m4",
            name: "ETH",
            symbol: "ETH",
            wChainId: 23,
            chainId: 42161,
            decimals: 18,
            coingeckoId: 'weth',
            contract: ethers.ZeroAddress,
            wrappedAddress: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
            logoURI: 'https://statics.mayan.finance/eth.png',
            realOriginChainId: 1,
            realOriginContractAddress: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
        },
        swiftFee: {
            tokens: [
                {
                    symbol: 'USDC',
                    logoURI: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389',
                    decimals: 6,
                    contract: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
                },
                {
                    symbol: 'USDT',
                    logoURI: 'https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663',
                    decimals: 6,
                    contract: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
                },
                {
                    symbol: 'WETH',
                    logoURI: 'https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295',
                    decimals: 18,
                    contract: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
                },
            ],
            feeManagers: ['0x26227ACE40de5671e8355fCAFf65a0522aa7b303', '0x54914A963c4197172130C26D496a367bD6609D88']
        }
    },
    {
        tokenBridgeAddress: '0x1D68124e65faFC907325e3EDbF8c4d84499DAa8b',
        wChainId: 24,
        chainId: 10,
        chainName: 'Optimism',
        rpcURL: 'https://mainnet.optimism.io',
        externalRpcURL: 'https://optimism.drpc.org',
        wrapContractAddress: '0x4200000000000000000000000000000000000006',
        logoURI: 'https://cdn.mayan.finance/optimism.png',
        blockExplorer: 'https://optimistic.etherscan.io',
        currencySymbol: 'ETH',
        fullChainName: 'Optimism',
        mode: 'EVM',
        mayanContractAddress: '0xBF5f3f65102aE745A48BD521d10BaB5BF02A9eF4',
        nameId: 'optimism',
        explorerName: 'OP Explorer',
        baseToken: {
            mint: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
            name: "ETH",
            symbol: "ETH",
            wChainId: 24,
            chainId: 10,
            decimals: 18,
            contract: '0x0000000000000000000000000000000000000000',
            coingeckoId: "weth",
            wrappedAddress: '0x4200000000000000000000000000000000000006',
            logoURI: 'https://statics.mayan.finance/assets/eth.png',
            realOriginChainId: 24,
            realOriginContractAddress: '0x4200000000000000000000000000000000000006',
        },
        swiftFee: {
            tokens: [
                {
                    symbol: 'USDC',
                    logoURI: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389',
                    decimals: 6,
                    contract: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
                },
                {
                    symbol: 'USDT',
                    logoURI: 'https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663',
                    decimals: 6,
                    contract: '0x01bFF41798a0BcF287b996046Ca68b395DbC1071',
                },
                {
                    symbol: 'WETH',
                    logoURI: 'https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295',
                    decimals: 18,
                    contract: '0x4200000000000000000000000000000000000006',
                },
            ],
            feeManagers: ['0x26227ACE40de5671e8355fCAFf65a0522aa7b303', '0x54914A963c4197172130C26D496a367bD6609D88']
        },
    },
    {
        tokenBridgeAddress: '0x1D68124e65faFC907325e3EDbF8c4d84499DAa8b',
        wChainId: 30,
        chainId: 8453,
        chainName: 'Base',
        rpcURL: 'https://mainnet.base.org/',
        externalRpcURL: 'https://base-mainnet.g.alchemy.com/v2/kVHhL4LVymG-KH-1d3t6umUE2sOumADq',
        wrapContractAddress: '0x4200000000000000000000000000000000000006',
        nameId: 'base',
        logoURI: 'https://cdn.mayan.finance/Base_N.png',
        blockExplorer: 'https://basescan.org',
        currencySymbol: 'ETH',
        fullChainName: 'Base',
        mode: 'EVM',
        mayanContractAddress: '0xBF5f3f65102aE745A48BD521d10BaB5BF02A9eF4',
        explorerName: 'basescan',
        baseToken: {
            mint: 'DWXe1hxpnb8LAH21iyXcjvMbiAGzoYyuCVQtRLvZdLYd',
            name: 'ETH',
            symbol: 'ETH',
            wChainId: 30,
            chainId: 8453,
            decimals: 18,
            contract: '0x0000000000000000000000000000000000000000',
            coingeckoId: 'weth',
            wrappedAddress: '0x4200000000000000000000000000000000000006',
            logoURI: 'https://statics.mayan.finance/assets/eth.png',
            realOriginChainId: 30,
            realOriginContractAddress: '0x4200000000000000000000000000000000000006'
        },
        swiftFee: {
            tokens: [
                {
                    symbol: 'USDC',
                    logoURI: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389',
                    decimals: 6,
                    contract: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
                },
                {
                    symbol: 'WETH',
                    logoURI: 'https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295',
                    decimals: 18,
                    contract: '0x4200000000000000000000000000000000000006',
                },
            ],
            feeManagers: ['0x26227ACE40de5671e8355fCAFf65a0522aa7b303', '0x54914A963c4197172130C26D496a367bD6609D88']
        },
    },
    {
        tokenBridgeAddress: '0x3Ff72741fd67D6AD0668d93B41a09248F4700560',
        wChainId: 44,
        chainId: 130,
        chainName: 'Unichain',
        // rpcURL: 'https://optimism-mainnet.public.blastapi.io',
        rpcURL: 'https://unichain-rpc.publicnode.com',
        // externalRpcURL: 'https://responsive-thrumming-breeze.optimism.quiknode.pro/aa9a177965feed21b177c60ff04f1771f69fcb36/',
        wrapContractAddress: '0x4200000000000000000000000000000000000006',
        explorerName: 'Uniscan',
        nameId: 'unichain',
        logoURI: 'https://cdn.mayan.finance/unichain.png',
        blockExplorer: 'https://uniscan.xyz',
        currencySymbol: 'ETH',
        fullChainName: 'Unichain',
        mode: 'EVM',
        mayanContractAddress: '0xBF5f3f65102aE745A48BD521d10BaB5BF02A9eF4',
        baseToken: {
            mint: '8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c',
            name: 'ETH',
            symbol: 'ETH',
            wChainId: 44,
            chainId: 130,
            decimals: 18,
            contract: '0x0000000000000000000000000000000000000000',
            coingeckoId: 'weth',
            wrappedAddress: '0x4200000000000000000000000000000000000006',
            logoURI: 'https://statics.mayan.finance/assets/eth.png',
            realOriginChainId: 44,
            realOriginContractAddress: '0x4200000000000000000000000000000000000006',
            verified: true,
        },
        swiftFee: {
            tokens: [
                {
                    symbol: 'USDC',
                    logoURI: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389',
                    decimals: 6,
                    contract: '0x078D782b760474a361dDA0AF3839290b0EF57AD6',
                },
                {
                    symbol: 'WETH',
                    logoURI: 'https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295',
                    decimals: 18,
                    contract: '0x4200000000000000000000000000000000000006',
                },
            ],
            feeManagers: ['0x26227ACE40de5671e8355fCAFf65a0522aa7b303', '0x54914A963c4197172130C26D496a367bD6609D88']
        },
    },
    {
        tokenBridgeAddress: '',
        wChainId: 38,
        chainId: 59144,
        chainName: 'Linea',
        rpcURL: 'https://linea-rpc.publicnode.com',
        wrapContractAddress: '0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f',
        nameId: 'linea',
        logoURI: 'https://cdn.mayan.finance/linea.png',
        blockExplorer: 'https://lineascan.build',
        currencySymbol: 'ETH',
        fullChainName: 'Linea',
        explorerName: 'lineascan',
        mode: 'EVM',
        mayanContractAddress: '',
        baseToken: {
            mint: '',
            name: 'ETH',
            symbol: 'ETH',
            wChainId: 38,
            chainId: 59144,
            decimals: 18,
            contract: '0x0000000000000000000000000000000000000000',
            coingeckoId: 'weth',
            wrappedAddress: '0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f',
            logoURI: 'https://statics.mayan.finance/assets/eth.png',
            realOriginChainId: 38,
            realOriginContractAddress: '0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f',
            verified: true,
        },
        swiftFee: {
            tokens: [
                {
                    symbol: 'USDC',
                    logoURI: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389',
                    decimals: 6,
                    contract: '0x176211869cA2b568f2A7D4EE941E073a821EE1ff',
                },
                {
                    symbol: 'WETH',
                    logoURI: 'https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295',
                    decimals: 18,
                    contract: '0x4200000000000000000000000000000000000006',
                },
            ],
            feeManagers: ['0x26227ACE40de5671e8355fCAFf65a0522aa7b303', '0x54914A963c4197172130C26D496a367bD6609D88']
        },
    },
    {
        mode: 'APTOS',
        nameId: 'aptos',
        tokenBridgeAddress: '0x576410486a2da45eee6c949c995670112ddf2fbeedab20350d506328eefc9d4f',
        wChainId: 22,
        chainId: 1998,
        chainName: 'Aptos',
        fullChainName: 'Aptos Chain',
        rpcURL: 'https://fullnode.mainnet.aptoslabs.com/v1',
        currencySymbol: 'APT',
        blockExplorer: 'https://explorer.solana.com/',
        logoURI: '/assets/aptos.png',
        mayanContractAddress: ethers.ZeroAddress,
        wrapContractAddress: 'NONE1111111111111111111111111111111111111111111',
        explorerName: 'AptosExplorer',
        baseToken: {
            mint: '6LNeTYMqtNm1pBFN8PfhQaoLyegAH8GD32WmHU9erXKN',
            name: "APT",
            symbol: "APT",
            wChainId: 22,
            chainId: 1998,
            decimals: 8,
            contract: ethers.ZeroAddress,
            coingeckoId: "aptos",
            wrappedAddress: 'NONE1111111111111111111111111111111111111111111',
            logoURI: '/assets/aptos.png',
        },
    },
    {
        mode: 'SUI',
        tokenBridgeAddress: '0x26efee2b51c911237888e5dc6702868abca3c7ac12c53f76ef8eba0697695e3d',
        wChainId: 21,
        chainId: 1999,
        nameId: 'sui',
        chainName: 'Sui',
        fullChainName: 'Sui Chain',
        explorerName: 'SuiScan',
        rpcURL: 'https://rpc.ankr.com/sui_mainnet',
        externalRpcURL: 'https://sui-mainnet-endpoint.blockvision.org',
        currencySymbol: 'SUI',
        blockExplorer: 'https://suiscan.xyz/mainnet',
        logoURI: 'https://cdn.mayan.finance/SUI.png',
        mayanContractAddress: '0x0000000000000000000000000000000000000000',
        wrapContractAddress: '0x0000000000000000000000000000000000000000',
        baseToken: {
            mint: 'G1vJEgzepqhnVu35BN4jrkv3wVwkujYWFFCxhbEZ1CZr',
            name: 'SUI coin',
            symbol: 'SUI',
            wChainId: 21,
            chainId: 1999,
            decimals: 9,
            contract: '0x2::sui::SUI',
            coingeckoId: 'sui',
            wrappedAddress: '0x2::sui::SUI',
            logoURI: 'https://cdn.mayan.finance/sui_coin.png',
            verified: true,
            verifiedAddress: "0x9258181f5ceac8dbffb7030890243caed69a9599d2886d957a9cb7656af3bdb3",
        }
    },
    {
        mode: 'EVM',
        tokenBridgeAddress: '',
        wChainId: 65_000,
        chainId: 999,
        chainName: 'Hyperliquid',
        fullChainName: 'Hyperliquid',
        explorerName: '',
        nameId: 'hypercore',
        logoURI: 'https://cdn.mayan.finance/HL_green.png',
        rpcURL: 'https://rpc.hyperliquid.xyz/evm',
        mayanContractAddress: '',
        wrapContractAddress: '',
        blockExplorer: 'https://app.hyperliquid.xyz/explorer',
        currencySymbol: 'HYPE',
        baseToken: {
            name: 'USDC',
            symbol: 'USDC',
            mint: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
            verified: true,
            contract: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
            chainId: 999,
            wChainId: 65_000,
            decimals: 6,
            logoURI: 'https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694',
            coingeckoId: 'usd-coin',
            realOriginContractAddress: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
            realOriginChainId: 65_000,
        },
    },
    {
        mode: 'EVM',
        tokenBridgeAddress: '',
        wChainId: 47,
        chainId: 999,
        chainName: 'HyperEVM',
        fullChainName: 'HyperEVM',
        nameId: 'hyperevm',
        logoURI: 'https://cdn.mayan.finance/HyperEVM.png',
        rpcURL: 'https://rpc.hypurrscan.io',
        mayanContractAddress: '',
        wrapContractAddress: '',
        blockExplorer: 'https://hyperevmscan.io',
        explorerName: 'HyperEVMScan',
        currencySymbol: 'HYPE',
        baseToken: {
            name: 'HYPE',
            symbol: 'HYPE',
            mint: 'null',
            verified: true,
            contract: '0x0000000000000000000000000000000000000000',
            chainId: 999,
            wChainId: 47,
            decimals: 18,
            logoURI: 'https://assets.coingecko.com/coins/images/50882/standard/hyperliquid.jpg?1729431300',
            coingeckoId: 'hyperliquid',
            realOriginContractAddress: '0x5555555555555555555555555555555555555555',
            realOriginChainId: 47,
        },
        swiftFee: {
            tokens: [
                {
                    symbol: 'USDC',
                    logoURI: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389',
                    decimals: 6,
                    contract: '0xb88339CB7199b77E23DB6E890353E22632Ba630f',
                },
                {
                    symbol: 'USDT',
                    logoURI: 'https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663',
                    decimals: 6,
                    contract: '0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb',
                },
            ],
            feeManagers: ['0x26227ACE40de5671e8355fCAFf65a0522aa7b303', '0x54914A963c4197172130C26D496a367bD6609D88']
        },
    },
    {
        mode: 'EVM',
        tokenBridgeAddress: '',
        wChainId: 48,
        chainId: 143,
        chainName: 'Monad',
        fullChainName: 'Monad',
        nameId: 'monad',
        logoURI: 'https://cdn.mayan.finance/monad.png',
        rpcURL: 'https://rpc1.monad.xyz',
        mayanContractAddress: '',
        wrapContractAddress: '',
        blockExplorer: 'https://monadvision.com',
        explorerName: 'MonadVision',
        currencySymbol: 'MON',
        baseToken: {
            mint: '',
            name: 'MON',
            symbol: 'MON',
            wChainId: 48,
            chainId: 143,
            decimals: 18,
            contract: '0x0000000000000000000000000000000000000000',
            coingeckoId: 'monad',
            wrappedAddress: '0x3bd359C1119dA7Da1D913D1C4D2B7c461115433A',
            logoURI: 'https://cdn.mayan.finance/MON.png',
            realOriginChainId: 48,
            realOriginContractAddress: '0x3bd359C1119dA7Da1D913D1C4D2B7c461115433A',
            verified: true
        },
        swiftFee: {
            tokens: [
                {
                    symbol: 'USDC',
                    logoURI: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389',
                    decimals: 6,
                    contract: '0x754704bc059f8c67012fed69bc8a327a5aafb603',
                },
                {
                    symbol: 'USDT',
                    logoURI: 'https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663',
                    decimals: 6,
                    contract: '0xe7cd86e13AC4309349F30B3435a9d337750fC82D',
                },
            ],
            feeManagers: ['0x26227ACE40de5671e8355fCAFf65a0522aa7b303', '0x54914A963c4197172130C26D496a367bD6609D88']
        }
    },
];


export const drivers: Driver[] = [
    {
        name: 'Jupiter',
        id: 'Jupiter',
        logo: '/assets/jupiter.png',
        address: new PublicKey("9YFeuz8q9WMSJpeNhNHj6LSbZnQ6BvDt5u9CV2ALhPWv")
    },
    {
        name: 'Prism',
        id: 'Prism',
        logo: '/assets/prism.png',
        address: new PublicKey("6X3ojqxk1cpjhcehK2SgTDt8m4SgeFrpFesXrfyW6bY8"),
    },
]
